module.exports = __webpack_public_path__ + "img/24t.0fff02c5.jpg";